import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Preloader from '../components/Preloader';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Blogdetails = () => {
  useEffect(() => {
    // Initialize scripts if needed
    if (window.initPathioScripts) {
      window.initPathioScripts();
    }
  }, []);

  return (
    <>
      <Preloader />
      <Sidebar />
      <Header />

      <main>

      <section className="ul-breadcrumb ul-section-spacing">
        <div className="ul-container">
          <h2 className="ul-breadcrumb-title">Blog Details</h2>
          <ul className="ul-breadcrumb-nav">
            <li><Link to="/">Home</Link></li>
            <li>
              <span className="separator"><i className="flaticon-right"></i></span>
            </li>
            <li>Blog Details</li>
          </ul>
        </div>
      </section>

      <div className="ul-section-spacing">
        <div className="ul-container">
          <div className="row ul-bs-row gy-5 flex-column-reverse flex-md-row">

            <div className="col-lg-4 col-md-5">
              <div className="ul-inner-sidebar">

                <div className="ul-inner-sidebar-widget ul-inner-sidebar-search">
                  <h3 className="ul-inner-sidebar-widget-title">Search</h3>
                  <div className="ul-inner-sidebar-widget-content">
                    <form action="#" className="ul-blog-search-form">
                      <input
                        type="search"
                        name="blog-search"
                        id="ul-blog-search"
                        placeholder="Search Here"
                      />
                      <button type="submit">
                        <span className="icon"
                          ><i className="flaticon-search"></i
                        ></span>
                      </button>
                    </form>
                  </div>
                </div>

                <div className="ul-inner-sidebar-widget categories">
                  <h3 className="ul-inner-sidebar-widget-title">Categories</h3>
                  <div className="ul-inner-sidebar-widget-content">
                    <div className="ul-inner-sidebar-categories">
                      <Link to="/donations">Charity <span>(08)</span></Link>
                      <Link to="/donations"
                        >Crowdfunding <span>(11)</span></Link
                      >
                      <Link to="/donations">Industries <span>(18)</span></Link>
                      <Link to="/donations">Innovations <span>(11)</span></Link>
                      <Link to="/donations">Technology <span>(07)</span></Link>
                    </div>
                  </div>
                </div>

                <div className="ul-inner-sidebar-widget posts">
                  <h3 className="ul-inner-sidebar-widget-title">Recent Posts</h3>
                  <div className="ul-inner-sidebar-widget-content">
                    <div className="ul-inner-sidebar-posts">

                      <div className="ul-inner-sidebar-post">
                        <div className="img">
                          <img
                            src="/assets/new-img/new/group-of-happy-volunteers-sorting-donations-while-2024-12-13-21-32-21-utc.jpg"
                            alt="Post Image"
                          />
                        </div>

                        <div className="txt">
                          <h4 className="title">
                            <Link to="/donations"
                              >Understanding Diabetes: A Bilingual Guide</Link
                            >
                          </h4>
                          <span className="date"> <span>May 12, 2025</span></span>
                        </div>
                      </div>

                      <div className="ul-inner-sidebar-post">
                        <div className="img">
                          <img
                            src="/assets/new-img/new/food-distribution-volunteers-help-needy-2025-02-19-10-27-15-utc.jpg"
                            alt="Post Image"
                          />
                        </div>

                        <div className="txt">
                          <h4 className="title">
                            <Link to="/donations"
                              >Understanding Diabetes: A Bilingual Guide</Link
                            >
                          </h4>
                          <span className="date"> <span>May 12, 2025</span></span>
                        </div>
                      </div>

                      <div className="ul-inner-sidebar-post">
                        <div className="img">
                          <img
                            src="/assets/new-img/new/group-of-volunteers-sorting-garbage-2025-04-02-09-20-13-utc.JPG"
                            alt="Post Image"
                          />
                        </div>

                        <div className="txt">
                          <h4 className="title">
                            <Link to="/donations"
                              >Understanding Diabetes: A Bilingual Guide</Link
                            >
                          </h4>
                          <span className="date"> <span>May 12, 2025</span></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="ul-inner-sidebar-widget tags">
                  <h3 className="ul-inner-sidebar-widget-title">Tag Cloud</h3>
                  <div className="ul-inner-sidebar-widget-content">
                    <div className="ul-inner-sidebar-tags">
                      <Link to="/donations">Crowdfunding</Link>
                      <Link to="/donations">Innovations</Link>
                      <Link to="/donations">Justice</Link>
                      <Link to="/donations">Lead</Link>
                      <Link to="/donations">Startup</Link>
                      <Link to="/donations">Technology</Link>
                      <Link to="/donations">Market</Link>
                      <Link to="/donations">Court</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-8 col-md-7">
              <div className="ul-blog-details ul-blog-inner mb-0">
                <div className="ul-blog-2 ul-blog-inner">
                  <div className="ul-blog-img">
                    <img
                      src="/assets/new-img/new/group-of-happy-volunteers-sorting-donations-while-2024-12-13-21-32-21-utc.jpg"
                      alt="Blog Image"
                    />
                  </div>
                  <div className="ul-blog-txt">
                    <div className="ul-blog-infos">

                      <div className="ul-blog-info">
                        <span className="icon"
                          ><i className="flaticon-account"></i
                        ></span>
                        <span className="text">By Admin</span>
                      </div>

                      <div className="ul-blog-info">
                        <span className="icon"
                          ><i className="flaticon-price-tag"></i
                        ></span>
                        <span className="text">Donation</span>
                      </div>
                    </div>
                    <h2 className="ul-blog-title">
                      Outstanding entrepreneurs and develop your skills.
                    </h2>
                    <div
                      className="ul-donation-details-summary-txt ul-blog-details-txt"
                    >
                      <p>
                        When to Use Lorem Ipsum generally, lorem ipsum is best
                        suited to keeping template fo looking bare or minimizing
                        the distractions of the draft copy. Second, use lorem
                        ipsum if you think placeholder text will distracting. in
                        voluptate velit esse. Cursus libero viverra.
                      </p>
                      <p>
                        One of the most remarkable applications of AI in
                        healthcare is in diagnostics. Machine and learning
                        algorithms are capable of analyzing vast amounts of
                        medical data with speed to unprecedente speed and
                        accuracy. This has led to earlier and more precise
                        disease speed detection, greatly enhancing the chances
                        of successful treatment.
                      </p>
                      <blockquote>
                        Mosico has been an invaluable partner to us. Any talent
                        we've worked with ha shown a deep understanding of
                        digital experiences. They're seamlessl integrate with or
                        team and meet the level of craft that we hold ourselves
                        accountable with our team and meet to. They're seamlessl
                        integrate with our team and meet
                      </blockquote>
                      <p>
                        One of the most remarkable applications of AI in
                        healthcare is in diagnostics. Machine and learning
                        algorithms are capable of analyzing vast amounts of
                        medical data with speed to unprecedente speed and
                        accuracy. This has led to earlier and more precise
                        disease speed detection, greatly enhancing the chances
                        of successful treatment.
                      </p>
                      <div className="ul-donation-details-summary-imgs">
                        <img
                          src="/assets/new-img/new/food-distribution-volunteers-help-needy-2025-02-19-10-27-15-utc.jpg"
                          alt="image"
                        />
                     
                      </div>
                      <p>
                        One of the most remarkable applications of AI in
                        healthcare is in diagnostics. Machine and learning
                        algorithms are capable of analyzing vast amounts of
                        medical data with speed to unprecedente speed and
                        accuracy. This has led to earlier and more precise
                        disease speed detection, greatly enhancing the chances
                        of successful treatment.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="ul-blog-details-actions">

                  <div className="tags-wrapper">
                    <h4 className="actions-title">Tags:</h4>
                    <div className="ul-blog-sidebar-tags tags">
                      <button type="button" className="tag">Reseller</button>
                      <button type="button" className="tag">Hosting</button>
                      <button type="button" className="tag">WP Hosting</button>
                    </div>
                  </div>

                  <div className="shares-wrapper">
                    <h4 className="actions-title">Share:</h4>
                    <div className="share-options">
                      <a href="https://facebook.com/pathio" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i className="flaticon-facebook"></i></a>
                      <a href="https://twitter.com/pathio" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><i className="flaticon-twitter"></i></a>
                      <a href="https://linkedin.com/company/pathio" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><i className="flaticon-linkedin-big-logo"></i></a>
                      <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="flaticon-instagram"></i></a>
                    </div>
                  </div>
                </div>

                <div className="ul-blog-details-bottom">

                  <div className="ul-blog-details-reviews">
                    <h3
                      className="ul-blog-details-inner-title ul-donation-details-summary-title"
                    >
                      02 Comments
                    </h3>

                    <div className="ul-blog-details-review">
                      <div className="main-comment">

                        <div className="ul-blog-details-review-reviewer-img">
                          <img
                            src="/assets/new-img/new/cardiologist-in-white-uniform-consulting-female-pa-2024-11-26-11-46-35-utc.JPG"
                            alt="Reviewer Image"
                          />
                        </div>

                        <div className="ul-blog-details-review-txt">
                          <p>
                            Phasellus eget fermentum mauris. Suspendisse nec
                            dignissim nulla. Integer non quam commodo,
                            scelerisque felis id, eleifend turpis. Phasellus in
                            nulla quis erat tempor tristique eget vel purus.
                            Nulla pharetra pharetra pharetra. Praesent varius
                            eget justo ut lacinia. Phasellus pharetra.
                          </p>
                          <div className="reviewer">
                            <h4 className="reviewer-name">Leslie Alexander</h4>
                            <h5 className="review-date">
                              March 20, 2023 at 2:37 pm
                            </h5>
                          </div>
                          <button className="ul-blog-details-review-reply-btn">
                            <i className="flaticon-reply"></i> Reply
                          </button>
                        </div>
                      </div>

                      <div className="ul-blog-details-review-replies">

                        <div className="ul-blog-details-review-reply">
                          <div className="main-comment">

                            <div className="ul-blog-details-review-reviewer-img">
                              <img
                                src="/assets/new-img/new/two-nutritionists-female-and-male-work-in-a-hospi-2025-02-16-08-36-11-utc.jpg"
                                alt="Reviewer Image"
                              />
                            </div>

                            <div className="ul-blog-details-review-txt">
                              <p>
                                Phasellus eget fermentum mauris. Suspendisse nec
                                dignissim nulla. Integer non quam commodo,
                                scelerisque felis id, eleifend turpis. Phasellus
                                in nulla quis erat tempor tristique eget vel
                                purus. Nulla pharetra pharetra pharetra.
                                Praesent varius eget justo ut lacinia. Phasellus
                                pharetra.
                              </p>
                              <div className="reviewer">
                                <h4 className="reviewer-name">Leslie Alexander</h4>
                                <h5 className="review-date">
                                  March 20, 2023 at 2:37 pm
                                </h5>
                              </div>
                              <button className="ul-blog-details-review-reply-btn">
                                <i className="flaticon-reply"></i> Reply
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="ul-blog-details-review-form-wrapper">
                    <h3
                      className="ul-blog-details-inner-title ul-donation-details-summary-title"
                    >
                      Leave a Comment
                    </h3>
                    <p>
                      Your email address will not be published. Required fields
                      are marked *
                    </p>
                    <form action="#" className="ul-contact-form ul-form">
                      <div className="row row-cols-2 row-cols-xxs-1 ul-bs-row">
                        <div className="col">
                          <div className="form-group">
                            <input
                              type="text"
                              name="name"
                              id="ul-blog-comment-name"
                              placeholder="Your Name"
                            />
                          </div>
                        </div>
                        <div className="col">
                          <div className="form-group">
                            <input
                              type="email"
                              name="email"
                              id="ul-blog-comment-email"
                              placeholder="Email Address"
                            />
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-group">
                            <input
                              type="text"
                              name="subject"
                              id="ul-blog-comment-subject"
                              placeholder="Subject"
                            />
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-group">
                            <textarea
                              name="message"
                              id="ul-blog-comment-msg"
                              placeholder="Type your message"
                            ></textarea>
                          </div>
                        </div>
                        <div className="col-12">
                          <button className="ul-btn">
                            <i
                              className="flaticon-fast-forward-double-right-arrows-symbol"
                            ></i>
                            Get in Touch
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </main>

      <Footer />
    </>
  );
};

export default Blogdetails;
